import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from './i18n'
import { registerNativeDeepLinks } from './router/nativeDeepLinks'

Vue.config.productionTip = false;

const initialLang = process.env.VUE_APP_INITIAL_LANG
if (initialLang === 'ru' || initialLang === 'en') {
  localStorage.setItem('lang', initialLang)
}

const isNativeApp = process.env.VUE_APP_NATIVE === 'true'
if (isNativeApp) {
  document.documentElement.classList.add('native-app')
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");

const initialRoute = process.env.VUE_APP_INITIAL_ROUTE
router.onReady(() => {
  const initializeRoute = async () => {
    const openedRoomLink = isNativeApp
      ? await registerNativeDeepLinks(router).catch(() => false)
      : false

    if (!openedRoomLink && initialRoute) {
      await router.replace(initialRoute)
      window.scrollTo(0, 0)
    }
  }

  void initializeRoute().catch(() => undefined)
})
